import { combineReducers } from 'redux';
import _omit from 'lodash/omit';

import errors from './errors';
import translations from './translations';

import {
  ACTION_ADD_SITE_SEO_DATA,
  ACTION_ADD_CUSTOM_TAGS,
  ACTION_DELETE_CUSTOM_TAG__REQUEST,
  ACTION_DELETE_CUSTOM_TAG__SUCCESS,
  ACTION_DELETE_CUSTOM_TAG__FAIL,
} from '../actionTypes';


const data = (state = {}, action) => {
  switch (action.type) {
    case ACTION_ADD_SITE_SEO_DATA:
      return action.payload.siteSeoData;

    default:
      return state;
  }
};

const customTags = (state = {}, action) => {
  switch (action.type) {
    case ACTION_ADD_CUSTOM_TAGS:
      return { ...state, ...action.payload.customTags };

    default:
      return state;
  }
};

const isCustomTagBeingDeleted = (state = {}, action) => {
  switch (action.type) {
    case ACTION_DELETE_CUSTOM_TAG__REQUEST:
      return { ...state, [action.payload.customTagId]: true };

    case ACTION_DELETE_CUSTOM_TAG__SUCCESS:
    case ACTION_DELETE_CUSTOM_TAG__FAIL:
      return _omit(state, action.payload.customTagId);

    default:
      return state;
  }
};

export default combineReducers({
  data,
  errors,
  translations,
  customTags,
  isCustomTagBeingDeleted,
});
